export const LANGUAGE_KEY = 'language';

export const Language = {
	En: 'en',
	Ru: 'ru',
	Hy: 'hy',
};
